import { Colors, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const DraftBadge = styled.div`
    display: flex;
    justify-content: center;
    place-items: center;
    background: ${Colors.galBlack31};
    border-radius: 4px;
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    white-space: nowrap;
    padding: 3px 10px 5px 10px;
    max-width: min-content;
    color: ${Colors.geoWhite100};
`;

export const ModerationBadge = styled.div`
    display: flex;
    justify-content: center;
    place-items: center;
    background: rgba(231, 137, 75, 1);
    border-radius: 4px;
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    white-space: nowrap;
    max-width: min-content;
    padding: 3px 10px 5px 10px;
    color: ${Colors.geoWhite100};
`;

export const RejectedBadge = styled.div`
    display: flex;
    justify-content: center;
    place-items: center;
    background: #ff0000;
    border-radius: 4px;
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    white-space: nowrap;
    max-width: min-content;
    padding: 3px 10px 5px 10px;
    color: ${Colors.geoWhite100};
`;

export const HiddenBadge = styled.div`
    display: flex;
    justify-content: center;
    place-items: center;
    background: ${Colors.geoWhite100};
    border-radius: 4px;
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    white-space: nowrap;
    max-width: min-content;
    padding: 3px 10px 5px 10px;
    color: ${Colors.galBlack100};
`;

export const CourseCompletedBadge = styled(DraftBadge)`
    background: #B6B6B5;
    padding: 6px 16px;
    @media(max-width: ${LayoutConst.screen.s}px) {
        padding: 3px 10px 5px 10px;
    }
`;

export const CourseActiveBadge = styled(DraftBadge)`
    background: #2A894F;
    padding: 6px 16px;
    @media(max-width: ${LayoutConst.screen.s}px) {
        padding: 3px 10px 5px 10px;
    }
`;

export const SubscriptionsBadge = styled.div`
    position: absolute;
    right: 16px;
    top: 12px;
    display: flex;
    justify-content: center;
    place-items: center;
    background: rgba(24, 26, 28, 0.4);
    backdrop-filter: blur(4px);
    border-radius: 4px;
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    white-space: nowrap;
    max-width: min-content;
    padding: 8px;
    color: ${Colors.galBlack10};

    @media(max-width: ${LayoutConst.screen.s}px) {
        background: transparent;
        padding: 0;
        font-size: 11px;
        line-height: 13px;
        font-weight: 400;
        color: ${Colors.galBlack47};
        backdrop-filter: none;
        justify-content: flex-start;
        place-items: flex-start;
        position: relative;
        width: 100%;
        top: 0;
        left: 0;
        margin-top: 4px;
    }
`;

export const RepostedBadge = styled.div.attrs({
    className: 'project-badge'
})`
    position: absolute;
    right: 16px;
    top: 12px;
    display: flex;
    justify-content: center;
    place-items: center;
    background: rgba(24, 26, 28, 0.4);
    backdrop-filter: blur(4px);
    border-radius: 4px;
    opacity: 1;
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    white-space: nowrap;
    max-width: min-content;
    padding: 8px;
    color: ${Colors.galBlack10};

    @media ${MEDIA.TABLET} {
        font-size: 11px;
        line-height: 13px;
        padding: 5.5px 8px;
        right: 8px;
        top: 8px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        // justify-content: flex-start;
        // place-items: flex-start;
        // position: relative;
        // width: 100%;
        // top: 0;
        // left: 0;
        
        // margin-top: 4px;
    }
`import { Colors, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const DraftBadge = styled.div`
    display: flex;
    justify-content: center;
    place-items: center;
    background: ${Colors.galBlack31};
    border-radius: 4px;
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    white-space: nowrap;
    padding: 3px 10px 5px 10px;
    max-width: min-content;
    color: ${Colors.geoWhite100};
`;

export const ModerationBadge = styled.div`
    display: flex;
    justify-content: center;
    place-items: center;
    background: rgba(231, 137, 75, 1);
    border-radius: 4px;
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    white-space: nowrap;
    max-width: min-content;
    padding: 3px 10px 5px 10px;
    color: ${Colors.geoWhite100};
`;

export const RejectedBadge = styled.div`
    display: flex;
    justify-content: center;
    place-items: center;
    background: #ff0000;
    border-radius: 4px;
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    white-space: nowrap;
    max-width: min-content;
    padding: 3px 10px 5px 10px;
    color: ${Colors.geoWhite100};
`;

export const HiddenBadge = styled.div`
    display: flex;
    justify-content: center;
    place-items: center;
    background: ${Colors.geoWhite100};
    border-radius: 4px;
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    white-space: nowrap;
    max-width: min-content;
    padding: 3px 10px 5px 10px;
    color: ${Colors.galBlack100};
`;

export const CourseCompletedBadge = styled(DraftBadge)`
    background: #B6B6B5;
    padding: 6px 16px;
    @media(max-width: ${LayoutConst.screen.s}px) {
        padding: 3px 10px 5px 10px;
    }
`;

export const CourseActiveBadge = styled(DraftBadge)`
    background: #2A894F;
    padding: 6px 16px;
    @media(max-width: ${LayoutConst.screen.s}px) {
        padding: 3px 10px 5px 10px;
    }
`;

export const SubscriptionsBadge = styled.div`
    position: absolute;
    right: 16px;
    top: 12px;
    display: flex;
    justify-content: center;
    place-items: center;
    background: rgba(24, 26, 28, 0.4);
    backdrop-filter: blur(4px);
    border-radius: 4px;
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    white-space: nowrap;
    max-width: min-content;
    padding: 8px;
    color: ${Colors.galBlack10};

    @media(max-width: ${LayoutConst.screen.s}px) {
        background: transparent;
        padding: 0;
        font-size: 11px;
        line-height: 13px;
        font-weight: 400;
        color: ${Colors.galBlack47};
        backdrop-filter: none;
        justify-content: flex-start;
        place-items: flex-start;
        position: relative;
        width: 100%;
        top: 0;
        left: 0;
        margin-top: 4px;
    }
`;

export const RepostedBadge = styled.div.attrs({
    className: 'project-badge'
})`
    position: absolute;
    right: 16px;
    top: 12px;
    display: flex;
    justify-content: center;
    place-items: center;
    background: rgba(24, 26, 28, 0.4);
    backdrop-filter: blur(4px);
    border-radius: 4px;
    opacity: 1;
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    white-space: nowrap;
    max-width: min-content;
    padding: 8px;
    color: ${Colors.galBlack10};

    @media ${MEDIA.TABLET} {
        font-size: 11px;
        line-height: 13px;
        padding: 5.5px 8px;
        right: 8px;
        top: 8px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        // justify-content: flex-start;
        // place-items: flex-start;
        // position: relative;
        // width: 100%;
        // top: 0;
        // left: 0;
        
        // margin-top: 4px;
    }
`